module.exports = __webpack_public_path__ + "static/media/logo-xing.ba7d9b79.svg";